import React from "react";

function ErrorPaymentBlocked() {
  return (
    <div className="uk-height-1-1 uk-flex uk-flex-center uk-flex-middle uk-flex-column uk-text-center">

      <h1 className="uk-margin-small-bottom">Payment Blocked</h1>

      <p className="uk-margin-small-top" style={{ maxWidth: '450px' }}>
        We can't fulfill this request because Clik2pay is currently blocked in your <b>Interac settings</b>.
      </p>

      <p className="uk-margin-small-top" style={{ maxWidth: '450px' }}>
        To continue, you'll need to <b>unblock</b> Clik2pay within your <b>Interac settings</b> or through your bank's mobile app. Once unblocked, please return to your email and click the payment link again.
      </p>

      <p className="uk-margin-small-top" style={{ maxWidth: '450px' }}>
        <b>Need help?</b> Visit the <a href={"https://etransfer.interac.ca/viewManagePreferenceRegistration.do?lang=en"} style={{color: '#7240a7'}}>Interac Help Centre</a>.
      </p>

    </div>
  )
}

export default ErrorPaymentBlocked
